import { Breadcrumb } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { RoutePaths } from 'constant';

interface Props {
  route: string;
  id: string;
}

export const TemplateBreadcrump: FC<Props> = ({ route, id }) => {
  return (
    <>
      <Breadcrumb.Item>
        <Link to={RoutePaths.templates}>
          <FormattedMessage id="templates" />
        </Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to={route}>
          <FormattedMessage id={id} />
        </Link>
      </Breadcrumb.Item>
    </>
  );
};
